import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	getLink: {
		data: {},
		error: '',
		isLoading: false,
		hasBeenLoaded: false
	},
	getLinks: {
		results: [],
		error: '',
		isLoading: false,
		hasBeenLoaded: false,
		total: 0
	},
	createLink: {
		data: {},
		error: '',
		isLoading: false,
		hasBeenLoaded: false
	}
};

export const linksSlice = createSlice({
	name: 'links',
	initialState,
	reducers: {
		getLink: (state) => {
			state.getLink.isLoading = true;
			state.getLink.hasBeenLoaded = false;
		},
		getLinkCompleted: (state, action) => {
			state.getLink.isLoading = false;
			state.getLink.data = action.payload;
			state.getLink.hasBeenLoaded = true;
			state.getLink.error = '';
		},
		getLinkFailed: (state, action) => {
			state.getLink.data = {};
			state.getLink.isLoading = false;
			state.getLink.hasBeenLoaded = false;
			state.getLink.error = action.payload;
		},
		getLinks: (state) => {
			state.getLinks.isLoading = true;
			state.getLinks.hasBeenLoaded = false;
		},
		getLinksCompleted: (state, action) => {
			state.getLinks.isLoading = true;
			state.getLinks.total = action.payload.total;
			state.getLinks.results = action.payload.results;
			state.getLinks.hasBeenLoaded = true;
			state.getLinks.error = '';
		},
		getLinksFailed: (state, action) => {
			state.getLinks.isLoading = false;
			state.getLinks.hasBeenLoaded = false;
			state.getLinks.error = action.payload;
		},
		createLink: (state) => {
			state.createLink.isLoading = true;
			state.createLink.hasBeenLoaded = false;
		},
		createLinkCompleted: (state, action) => {
			state.createLink.isLoading = true;
			state.createLink.data = action.payload;
			state.createLink.hasBeenLoaded = true;
			state.createLink.error = '';
		},
		createLinkFailed: (state, action) => {
			state.createLink.data = {};
			state.createLink.isLoading = false;
			state.createLink.hasBeenLoaded = false;
			state.createLink.error = action.payload;
		}
	}
});

export const {
	getLink,
	getLinkCompleted,
	getLinkFailed,
	getLinks,
	getLinksCompleted,
	getLinksFailed,
	createLink,
	createLinkCompleted,
	createLinkFailed
} = linksSlice.actions;

export default linksSlice.reducer;
